module.exports = __webpack_public_path__ + "img/shopee_9thb_0005.dfb7648c.png";